import { useLocation } from 'react-router-dom';
import { ClaimSubmissionResponse } from 'all-in-one-shared-api';
import SubmitSuccessPage from './SubmitSuccessPage';

export const ClaimSubmissionSuccessPage = () => {
  const { state } = useLocation();
  const { referenceNo, remark, receiptWaiverAmount } = state as ClaimSubmissionResponse;

  return <SubmitSuccessPage referenceNo={referenceNo} remark={remark} receiptWaiverAmount={receiptWaiverAmount} />;
};
